"use client"

import { Car } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CarIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CarIcon = component(Icon)({ as: Car })
